module.exports = __webpack_public_path__ + "img/yangDetail1.452be42e.jpg";